import React from "react";
import ReactDOM from "react-dom";

const CartNotification = ({itemName, itemNumber, skuImg}) => {
  return (
    <div className="d-flex flex-column gap-2" style={{width: '200px'}}>
      <span style={{fontWeight: 'bold'}}>Recently Added to Bag</span>
      <div className="d-flex justify-content-start align-items-center">
        <img src={skuImg} alt={itemNumber} width={60} height={60} />
        <div className="d-flex flex-column gap-2 ml-2">
          <span>{itemName}</span>
          <span>{itemNumber}</span>
        </div>
      </div>
    </div>
  )
}

export function showAddToCartNotification({itemName, itemNumber, skuImg, duration}) {
  const cartNotificationRoot  = document.getElementById('cart-notification-root');
  if(cartNotificationRoot ){
    const notificationContainer = document.createElement('div');
    cartNotificationRoot.appendChild(notificationContainer);
    
    ReactDOM.render(
      <CartNotification itemName={itemName} itemNumber={itemNumber} skuImg={skuImg} />,
      notificationContainer,
      () => {
        requestAnimationFrame(() => {
          notificationContainer.classList.add('show');
        });
      }
    );

    setTimeout(() => {
      notificationContainer.classList.remove('show');

      setTimeout(() => {
        ReactDOM.unmountComponentAtNode(notificationContainer);
        cartNotificationRoot.removeChild(notificationContainer);
      }, 300);
    }, duration);
  }
}